<div>
  <ion-card color="warning">
    <ion-fab vertical="top" horizontal="end">
      <ion-fab-button color="danger" size="small">
        <ion-icon name="alert-sharp"></ion-icon>
      </ion-fab-button>
    </ion-fab>
    <ion-card-header>
      <ion-card-title>
        {{"PUZZLE.incompatibility_warning." + incompatibility + ".title" | translate }}
      </ion-card-title>
    </ion-card-header>
    <ion-card-content>
      {{"PUZZLE.incompatibility_warning." + incompatibility + ".message" | translate }}
    </ion-card-content>
  </ion-card>
</div>

